/**
 * LoginScreen — `/login`, `/login/password` et l'ancienne adresse `/login-code`, sur le design
 * system (posé par `loginScreen` dans `navigationScreens.js`).
 *
 * Un fil : le crochet tient l'étape et les appels, le view-model choisit ce que montre la page.
 */
import { LoginPage } from "../../../../../../design-system"
import { AuthStatusBar } from "../AuthStatusBar"
import { type LoginRoute, useLoginState } from "./useLoginState"

export function LoginScreen({ route }: { route?: LoginRoute }) {
    const { content, onBack } = useLoginState(route)

    return (
        <>
            <LoginPage content={content} onBack={onBack} />
            <AuthStatusBar />
        </>
    )
}

export default LoginScreen
